import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useMobileViewport } from 'hooks/useMobileViewport';
import { ROUTES } from 'utils/constants';
import styles from './ScrollToTopButton.module.scss';
import { ChevronUp } from 'lucide-react';

const BODY_SCROLL_PAD_CLASS = 'scroll-to-top-visible';

export default function ScrollToTopButton() {
  const { t } = useTranslation();
  const location = useLocation();
  const isMobile = useMobileViewport();
  const [visible, setVisible] = useState(false);
  const hideForBillsLedgerMobile =
    isMobile && location.pathname.startsWith(ROUTES.BILLS_LEDGER.ROOT);
  const hideForCustomerMenu =
    location.pathname === ROUTES.INSTOREQR.MENU ||
    location.pathname.startsWith(`${ROUTES.INSTOREQR.MENU}/`);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200); // show after scrolling down
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // run once on mount

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const applyPad =
      visible && !hideForBillsLedgerMobile && !hideForCustomerMenu;
    document.body.classList.toggle(BODY_SCROLL_PAD_CLASS, applyPad);
    return () => document.body.classList.remove(BODY_SCROLL_PAD_CLASS);
  }, [hideForBillsLedgerMobile, hideForCustomerMenu, visible]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  if (hideForBillsLedgerMobile || hideForCustomerMenu) {
    return null;
  }

  return (
    <button
      className={`${styles.scrollToTopBtn} ${visible ? styles.show : ''}`}
      onClick={scrollToTop}
      aria-label={t(
        'components.ScrollToTopButton.ScrollToTopButton.scroll_to_top_1',
      )}
    >
      <ChevronUp />
    </button>
  );
}
